import { Constants } from '../../shared/Constants.js';
import { Utils } from '../../shared/Utils.js';

/**
 * Day grid rendering (incl. range preview hover).
 */
export function renderDays(picker) {
  const $ = window.jQuery;
  const GDT = window.GenericDateTime;
  const currentMonth = GDT.from(picker.state.viewDate);
  const today = GDT.now();
  const selected = GDT.from(picker.state.currentDate);
  const isRange = !!picker.config.range;

  const firstDay = GDT.from(picker.state.viewDate).startOf('month');
  const startDay = firstDay.clone().subtract(firstDay.toDate().getDay(), 'days');

  const grid = $('<div class="gdp-days-grid"></div>');
  const weekDays = Utils.getWeekdayNames('short', picker.config.locale);
  weekDays.forEach((d) => grid.append(`<div class="gdp-day gdp-day-header">${d}</div>`));

  let rangeA = picker.state.startDate ? GDT.from(picker.state.startDate).startOf('day') : null;
  let rangeB = picker.state.endDate ? GDT.from(picker.state.endDate).startOf('day') : null;
  let isPreview = false;
  if (
    isRange &&
    rangeA &&
    !picker.state.endDate &&
    picker.state.rangeStep === 'end' &&
    picker.state.hoverDate
  ) {
    rangeB = GDT.from(picker.state.hoverDate).startOf('day');
    isPreview = true;
    if (rangeB.isBefore(rangeA, 'day')) {
      const swap = rangeA;
      rangeA = rangeB;
      rangeB = swap;
    }
  }

  const tempDate = startDay.clone();
  const min = picker.config.min ? GDT.from(picker.config.min).startOf('day') : null;
  const max = picker.config.max ? GDT.from(picker.config.max).startOf('day') : null;

  for (let i = 0; i < Constants.CALENDAR_SLOTS; i++) {
    const isCurrentMonth = tempDate.get('month') === currentMonth.get('month');
    const isToday = tempDate.isSame(today, 'day');
    const isSelected = !isRange && selected && tempDate.isSame(selected, 'day');

    let isFiltered = false;
    if (picker.config.filters.date && !picker.config.filters.date(tempDate)) isFiltered = true;
    if (min && tempDate.isBefore(min, 'day')) isFiltered = true;
    if (max && tempDate.isAfter(max, 'day')) isFiltered = true;

    const isRangeStart = !!(rangeA && tempDate.isSame(rangeA, 'day'));
    const isRangeEnd = !!(rangeB && tempDate.isSame(rangeB, 'day'));
    const isInRange =
      !!(rangeA && rangeB && !tempDate.isBefore(rangeA, 'day') && !tempDate.isAfter(rangeB, 'day'));

    let classes = 'gdp-day';
    if (!isCurrentMonth) classes += ' gdp-day-out';
    if (isToday) classes += ' today';
    if (isSelected) classes += ' selected';
    if (isRangeStart) classes += ' range-start selected';
    if (isRangeEnd) classes += ' range-end selected';
    if (isInRange && !isRangeStart && !isRangeEnd) {
      classes += isPreview ? ' range-preview' : ' in-range';
    }
    if (isFiltered) classes += ' disabled';

    const dayEl = $(`<div class="${classes}">${tempDate.get('day')}</div>`);
    const cellDate = tempDate.toDate();

    if (!isFiltered) {
      dayEl.on('click', () => picker._selectDate(cellDate));
      if (isRange && picker.state.rangeStep === 'end' && picker.state.startDate && !picker.state.endDate) {
        dayEl.on('mouseenter', () => {
          const prev = picker.state.hoverDate;
          if (prev && GDT.from(prev).isSame(GDT.from(cellDate), 'day')) return;
          picker.state.hoverDate = cellDate;
          picker._updateContent();
        });
      }
    }

    grid.append(dayEl);
    tempDate.add(1, 'day');
  }

  if (isRange && picker.state.rangeStep === 'end' && picker.state.startDate && !picker.state.endDate) {
    grid.on('mouseleave', () => {
      if (!picker.state.hoverDate) return;
      picker.state.hoverDate = null;
      picker._updateContent();
    });
  }

  return grid;
}
